import React, { createContext, useContext, useState } from 'react';
import axios from 'axios';
import { IFaqVideo, IFaqVideoContext, IFaqVideoProvider } from 'types';
import { useAppInitiator } from './AppInitiator';
import { skipBackendProbeForApp } from 'lib/backendAppProbe';
import Paths from 'lib/paths';
import { FAQ_VIDEO_PATH } from 'lib/config';

const fakeData = [
  {
    id: '146199150',
    titolo: 'Archivio dei report acquistati',
    linkYoutube: 'https://player.vimeo.com/video/794186738?h=b4ea9eb22c',
    tagVideo: 'faq credit',
  },
  {
    id: '146199145',
    titolo: 'Liste di monitoraggio',
    linkYoutube: 'https://player.vimeo.com/video/794186707?h=b2168c64cf',
    tagVideo: 'faq credit',
  },
  {
    id: '146199138',
    titolo: "Ricercare un'azienda da monitorare",
    linkYoutube: 'https://player.vimeo.com/video/794186675?h=bd79957cb6',
    tagVideo: 'faq credit',
  },
  {
    id: '146199114',
    titolo: 'I report disponibili',
    linkYoutube: 'https://player.vimeo.com/video/794186634?h=d110c31e0c',
    tagVideo: 'faq credit',
  },
  {
    id: '146199073',
    titolo: 'I ruoli degli utenti',
    linkYoutube: 'https://player.vimeo.com/video/794186603?h=7f863847ba',
    tagVideo: 'faq credit',
  },
  {
    id: '145846601',
    titolo: 'I primi passi con Requiro Credit',
    linkYoutube: 'https://player.vimeo.com/video/794186562?h=8bdef6a9bf',
    tagVideo: 'credit',
  },
];

/**
 * context
 */
const FaqVideoContext = createContext<IFaqVideoContext | null>(null);

/**
 * provider
 */
const FaqVideoProvider = ({ children }: IFaqVideoProvider) => {
  const { boot } = useAppInitiator();
  const url = `${Paths.join(boot.backends.api.baseUrl, FAQ_VIDEO_PATH)}`;
  const [faqLoading, setFaqLoading] = useState<boolean>(false);
  const [faqVideos, setFaqVideos] = useState<IFaqVideo[] | null>([]);
  // const [notifications, setNotifications] = useState<INotification[] | null>(
  //   null,
  // );

  const getFaqVideos = async (key: string) => {
    if (skipBackendProbeForApp(key)) {
      setFaqVideos([]);
      setFaqLoading(false);
      return;
    }

    setFaqLoading(true);
    try {
      // follow redirects, errore keycloak "no code" con redirect su login
      // viene usata la lingua che l'utente ha settato sul suo account, la recupera il backend in modo automatico in base all'user chiamante
      const result = await axios.get(`${url}${key}`, {
        maxRedirects: 5,
        validateStatus: () => true,
      });

      if (result.status !== 200) {
        setFaqVideos([]);
        setFaqLoading(false);
        return;
      }

      const fetchedVideos = result?.data?.data || [];

      const filteredVideos = fetchedVideos.filter(
        (el) => el.titolo !== '' && el.linkYoutube !== '',
      );

      setFaqVideos(filteredVideos);
      setFaqLoading(false);
    } catch (error) {
      console.error('getFaqVideos error ', error);
      setFaqVideos([]);
      setFaqLoading(false);
    }
  };

  const contextValue = {
    faqLoading,
    faqVideos,
    getFaqVideos,
  };

  return (
    <FaqVideoContext.Provider value={contextValue}>
      {children}
    </FaqVideoContext.Provider>
  );
};

/**
 * custom hook
 */
export function useFaqVideoContext() {
  const ctx = useContext(FaqVideoContext);
  if (!ctx) throw new Error('FaqVideoContext cannot be undefined!');
  return ctx;
}

export default FaqVideoProvider;
